// Module
var code = "<div ng-repeat=\"b in vm.formTemplate.blocks track by $index\" class=\"flex\" ng-class=\"b.config.classes\">\r\n    <form-block flex form-block=\"b\" template=\"vm.formTemplate\" on-change=\"vm.onChange()\"></form-block>\r\n</div>\r\n";
// Exports
module.exports = code;